import { useEffect, useState } from 'react'
import Layout from '../../components/Layout'
import FidelityDashboard from './view'
import { useSelector } from 'react-redux'

const FidelityDashboardContainer = () => {
  const [alert, setAlert] = useState({ message: '', open: false })
  const userPermissions = useSelector((state) => state.fidelity.userPermissions)

  useEffect(() => {
    if (
      (userPermissions?.cashWhoCanRedeem &&
        userPermissions?.cashWhoCanRedeem?.status === 2) ||
      (userPermissions?.cashWhoCanJoin &&
        userPermissions?.cashWhoCanJoin?.status === 2)
    ) {
      const messages = []
      if (userPermissions?.cashWhoCanJoin?.status === 2)
        messages.push(userPermissions?.cashWhoCanJoin?.message)
      if (userPermissions?.cashWhoCanRedeem?.status === 2)
        messages.push(userPermissions?.cashWhoCanRedeem?.message)
      const messageLabel = messages.join(' + ')
      setAlert({
        message: messageLabel,
        open: true,
      })
    } else {
      setAlert({
        message: '',
        open: false,
      })
    }
  }, [userPermissions?.cashWhoCanRedeem, userPermissions?.cashWhoCanJoin])

  return (
    <Layout>
      <FidelityDashboard alert={alert} />
    </Layout>
  )
}

export default FidelityDashboardContainer
